export default function stripQueryString(path) {
  return path.split("?")[0];
}
